module.exports = __webpack_public_path__ + "img/icon-stakewise-green.ff0b23e6.svg";